module.exports={
    // 登录页
    sjhm: '手机号码',
    qsrdxyzm:'请输入短信验证码',
    fsyzm:'发送验证码',
    login:'登录',
    yIDhmmdl:'以ID和密码登录',
    qsrID:'请输入ID',
    qsrmm:'请输入密码',
    ysjhmdl:'以手机号码登录',
	xzsq	:'请选择社区',
	zhmmcw	:'账号或者密码错误',
    //新添加的
    zc:'注册',
    zhmm:'重置密码',
    qsrsjhm:'请输入手机号码',
    mhzxhq:'秒后重新获取',
    hqyzmsb:'获取验证码失败！',
    sbbczhmqx:'设备不存在或无权限！',
    ryzc:'人员注册',
    sfz:'身份证',
    hz:'护照',
    jzz:'居住证',
    jsz:'驾驶证',
    nbool:'男',
    ngril:'女',
    qxkmmm:'请填写开门密码！',
    qxgh:'请填写工号！',
    scgg:'上传成功',
    scsb:'上传失败',
	tpgxsb:'图片更新失败',
    xlh:'序列号',
    wsh:'未审核',
    ysh:'已审核',
    rq:'日期',
    cd:'迟到',
    jb:'加班',
    zat:'早退',
    qtxbt:'请填写标题',
    qtxnr:'请填写内容',
    ysdfkgx:'已收到您的反馈，感谢您的宝贵意见！',
    fksb:'反馈失败',
    lya:'打开蓝牙',
    ss:'搜索',
    lykm:'蓝牙开门',
    cx:'查询',
    yc:'一次',
    lc:'俩次',
    zx:'在线',
    lx:'离线',
    kmen:'开门',
    
    // 首页
    yckm:'远程开门',
    fkyy:'访客预约',
    fxys:'分享钥匙',
    ewmkm:'二维码开门',
    smkm:'扫码开门',
    yjkm:'一键开门',
    sy:'首页',
    zzzc:'自主注册',
    sb:'设备',
    wd:'我的',
	cw:'错误',
    // 远程开门页面
    sbmhzwz:'设备名或者位置',
    cxwz:'查询位置',
    sbwz:'设备位置',
    zt:'状态',
    km:'开门',
    kmcg:'开门成功',
    kmsb:'开门失败',
    // 访客预约页面
    xm:'姓名',
    rlzp:'人脸照片',
    tj:'添加',
    zjlx:'证件类型',
    zjh:'证件号',
    xb:'性别',
    sfcs:'省份城市',
    sxrs:'随性人数',
    syo:'事由',
    fwyxq:'访问有效期',
    bfrhm:'被访人号码',
    bfrxm:'被访人姓名',
    tjyy:'提交预约',
    // 分享钥匙页面
    sssb:'搜索设备',
    xzsb:'选择设备',
    wsb:'无设备',
    fwcs:'访问次数',
    bxcs:"不限次数",
    qjzewmdzjt:'（请将此二维码对准机器镜头扫码开门）',
    fxewm:'生成分享二维码',
	fxmm:'分享密码',
    // 自主注册页面
    jg:'籍贯',
    hj:'户籍',
    qybm:'企业部门',
    kh:'卡号',
    kmmm:'开门密码',
    gh:'工号',
    qd:'确定',
    qtxsjhm:'请填写手机号码',
    qtxxm:'请填写姓名',
    qxzbm:'请选择部门',
    qszkmmm:'请设置开门密码',
    qtxgh:'请填写工号',
    zccg:'注册成功',
    zcsb:'注册失败',
    // 我的页面
    txjl:'通行记录',
    fkjl:'访客记录',
    kqrb:'考勤日报',
    fkwm:'反馈我们',
    tcdl:'退出登录',
    // 通行记录页面
    txsj:'通行时间',
    kmlx:'开门类型',
    // f访客记录页面
    lfsj:'来访时间',
    shzt:'审核状态',
    mygd:'没有更多',
    // 反馈我们页面
    bt:'标题',
    qsrbt:'请输入标题',
    ly:'留言',
    qsrly:'请输入留言',
    tjfk:'提交反馈',
    // 退出登录页面
    sfqdtc:'是否确定退出?',
    qx:'取消',
	// 设备搜索页面
	sbss:'设备搜索',
	kysb:'可用设备',
	ssjg:'搜索结果',
	sbtj:'设备添加',
	sblx:'设备类型',
	sfwzcj:'是否为注册机',
	qxz:'请选择',
	azwz:'安装位置',
	kmzt:'开门状态',
	wifimm:'wifi密码',
	
	// 设备设置页面
	wlgl:'网络管理',
	yggl:'员工管理',
	qxfp:'权限分配',
	gxqx:'更新权限',
	cqsb:'重启设备',
	cshsb:'初始化设备',
	scsb:'删除设备',
	cshPopTips:'当前操作将删除所有用户权限，再下载全部用户权限。',
	qjscz:'请谨慎操作！',
	qrgxqxm:'确认更新权限吗？',
	qrcqsbm:'确认重启设备吗？',
	dqczjscsb:'当前操作将删除设备。',
	shgl:'审核管理',
	bmgl:'部门管理',
	rygl:'人员管理',
	ts:'提示',
	sbsccg:'设备删除成功',
	sbbcz:'设备不存在',
	sbyc:'设备异常，请检查设备是否在线',
	mqxhzhmmcw:'没有权限或账号密码错误',
	gxqxsb:'更新权限失败,错误码',
	gxqxcg:'更新权限成功',
	sfyzgq:'身份验证过期，请重新登录重试',
	qsryhmm:'请输入用户密码',
	qcsbcg:'清除设备成功',
	mmcw:'密码错误',
	sbbzxhyc:'设备不在线或异常',
	// 网络管理页面
	czsb:'查找设备',
	wifisz:'WIFI设置',
	qsrSSID:'请输入SSID',
	ytwsz:'以太网设置',
	DHCPms:'DHCP模式',
	IPdz:'IP地址',
	zwym:'子网掩码',
	wg:'网关',
	qsrIP:'请输入IP',
	qsrMASK:'请输入MASK',
	qsrGATEWAY:'请输入GATEWAY',
	sgsz:'4G设置',
	tjxg:'提交修改',
	qxljsb:'请先连接设备',
	qxzms:'请选择模式',
	bnwk:'不能为空',
	wificsszcg:'WiFi参数设置成功',
	wifiszsbcwm:'WIFI设置失败，错误码',
	mmszsb:'密码设置失败',
	szwlmssb:'设置网络模式失败',
	ipdzbnwk:'IP地址不能为空',
	ytwcsszcg:'以太网参数设置成功',
	ytwcsszsb:'以太网参数设置失败',
	kqcg:'开启成功',
	gbcg:'关闭成功',
	kqsb:'开启失败',
	opentips:'open失败！如open多次失败请重连设备后再试',
	
	sbtjcgzzszwifics:'设备添加成功,正在设置WIFI参数',
	sbtjcg:'设备添加成功',
	zzcxpzwifi:'正在重新配置WIFI',
	sbycz:'设备已存在',
	tjsbsb:'添加设备失败',
	// 部门管理
	gm:'改名',
	sc:'删除',
	xgcg:'修改成功',
	bmbcz:'部门不存在',
	myqxhzhcw:'没有权限或账号错误',
	sbhryygl:'设备或人员已关联，需先清除关联',
	tjcg:'添加成功',
	yczgwj:'已存在该文件',
	gjdbnbcz:'该节点不能被操作',
	bmsc:'部门删除',
	xgmc:'修改名称',
	tjdbmmc:'添加的部门名称',
	tjzbm:'添加子部门',
	// 人员管理页面
	bm:'部门',
	wsp:'未审批',
	rlwzc:'人脸未注册',
	rlbfmzc:'人脸部分注册',
	rlzcsb:'人脸注册失败',
	xg:'修改',
	sccg:'删除成功',
	rybcz:'人员不存在',
	// 人员添加页面
	tjry:'添加人员',
	yhxm:'用户姓名',
	qsryhxm:'请输入用户姓名',
	zjhm:'证件号码',
	bmxz:'部门选择',
	yxkssj:'有效开始时间',
	xzrq:'选择日期',
	yxjssj:'有效结束时间',
	sztx:'设置头像',
	bc:'保存',
	qxzxb:'请选择性别',
	qsrzjh:'请输入证件号',
	qsrkh:'请输入卡号',
	qsrgh:'请输入工号',
	qsrkmmm:'请输入开门密码',
	qsryxkssj:'请输入有效开始时间',
	qsryxjssj:'请输入有效结束时间',
	ryycz:'人员已存在',
	khycz:'卡号已存在',
	zcsbbcz:'注册设备不存在',
	ghycz:'工号已存在',
	// 人员修改
	xgryzl:'修改人员资料',
	khbcz:'卡号不存在',
	sbcwm:'失败！错误码',
	ryxxhqsb:'人员信息获取失败',
	// 权限分配
	sqzt:'授权状态',
	wx:'无效',
	yx:'有效',
	tbzt:'同步状态',
	wtb:'未同步',
	rlwtb:'人脸未同步',
	kwtb:'卡未同步',
	sbmmwtb:'设备密码未同步',
	tb:'同步',
	xz:'选择',
	qxqx:'全选',
	sq:'授权',
	qxzsb:'请选择设备',
	qr:'确认',
	qxzsqsb:'请选择授权设备',
	bftbsb:'部分同步失败',
	qcktbzt:'请查看同步状态',
	tbsbqcs:'同步失败,请再次审核重试',
	bfscsb:'部分删除失败',
	scsbqcs:'删除失败,请再次审核重试',
	tjmk:'添加门卡',
	rysc:'人员删除',
	cg:'成功',
	

    //再次新加
	sygx1:'随意勾选 1',
	qrmm:'确认密码',
	zhmmyx:'找回密码邮箱',
	zzhmm:'找回密码',
	yxyzm:'邮箱验证码',
	hqyxyzm:'获取邮箱验证码',
	dt:'读头',
	mj:'门禁',
	jin:'进',
	chu:'出',
	yes:'是',
	no:'否',
	ysdyy:'已是第一页',
	syy:'上一页',
	xyy:'下一页',
	rmcs:'热门城市',
	xzgjhdq:'选择国家或地区',
    zhhyzmcw:'账号或验证码错误',
    zhhmmcw:'账号或密码错误',
    xyhzc:'新用户注册',
    yhm:'用户名',
    qymc:'企业名称',
    yx:'有效',
    qsryx:'请输入邮箱',
	yzms:'验证码是',
    qsryxyzm:'请输入邮箱验证码',
    yxyzm:'邮箱验证码不正确！',
    yzmbzq:'验证码不正确',
    qsryhm:'请输入用户名',
    hqyzmcg:'获取验证码成功！',
    yhycz:'用户已存在',
    mm:'密码',
    xmm:'新密码',
    xgmm:'修改密码',
    jmm:'旧密码',
    bf:'拜访',
    qt:'洽谈',
    yycg:'预约成功',
    yysb:'预约失败',
    bfrbcz:'被访问人不存在',
    fkmhsjhmycz:'访客名或手机号码已存在',
    mqtczsb:'MQTT操作失败',
    ljfghy:'立即分享给好友',
    fzlj:'复制链接',
    bnzydqsj:'不能早于当前时间',
    yxqbn:'有效期不能大于7天',
    rqxz:'日期',
    szcg:'设置成功',
    szsb:'设置失败',
    yhbcz:'用户不存在',

    khkm:'卡号开门',
    mmkm:'密码开门',
    zwkm:'指纹开门',
    rlkm:'人脸开门',

    // 手机号国家区
    zgdl:'中国大陆',
    zgxg:'中国香港',
    zgam:'中国澳门',
    zgtw:'中国台湾',
    afh:"阿富汗",
    ade:'安道尔',
    agt:'阿根廷',
    ymny:'亚美尼亚',
    alb:'阿鲁巴',
    adl:"奥地利",
    asbj:'阿塞拜疆',

    bhm:'巴哈马',
    bl:'巴林',
    bbds:'巴巴多斯',
    bjst:'巴基斯坦',
	bx:'巴西',
    bels:'白俄罗斯',
    bls:'比利时',
	
    cxx:'朝鲜',
    cdjny:'赤道几内亚',
    dg:'德国',
    dm:'丹麦',
    jbt:'吉布提',
    dmnjghg:'多米尼加共和国',
    els:'俄罗斯',
    egde:'厄瓜多尔',
    aj:'埃及',
    aseby:'埃塞俄比亚',

    fg:'法国',
    fl:'芬兰',
    flb:'菲律宾',
    fdg:'梵蒂冈',

    gby:'冈比亚',
    ggghg:'刚果共和国',
    glby:'哥伦比亚',
    gb:'古巴',
    hg:'韩国',
    hl:'荷兰',
    hd:'海地',

    jbz:'柬埔寨',
    jlbs:'基里巴斯',
    jny:'几内亚',
    jbbw:"津巴布韦",
    kml:'喀麦隆',
    kmqt:'开曼群岛',
    kny:'肯尼亚',
    kwt:'科威特',
    kldy:'克罗地亚',
    lys:'老挝',
    lby:'利比亚',
    lwd:'卢旺达',
    mg:'美国',
    mlxy:'马来西亚',
    mxg:'墨西哥',
    nf:'南非',
    nbe:'尼泊尔',
    nrly:'尼日利亚',
    nw:'挪威',
    plqd:'帕劳群岛',
    pty:'葡萄牙',
    rb:'日本',
    rd:'瑞典',
    rs:'瑞士',
    stalb:'沙特阿拉伯',
    sd:'苏丹',
    slxy:'圣卢西亚',
    tgs:'泰国',
    tjs:'汤加',
    teq:'土耳其',
    wnrl:'委内瑞拉',
    wl:'文莱',
    wkl:'乌克兰',
    xxl:'新西兰',
    xjb:'新加坡',
    xby:'西班牙',
    xl:'希腊',
    xyl:'匈牙利',
    ydl:'意大利',
    yg:'英国',
    ydnxy:'印度尼西亚',
    yd:'印度',
    yn:'越南',
    ylk:'伊拉克',
    zl:'智利',
    zfghg:'中非共和国',


    wz:'位置',
    lym:'蓝牙',
    kmcg:'开门成功',
    kmsb:'开门失败',
    qxdkly:'请先打开蓝牙',
    手机号码在同一个公司已存在:'手机号码在同一个公司已存在',
    有效期要大于当前时间:'有效期要大于当前时间',
    请选择部门:'请选择部门',
    生成成功:  '生成成功',
    长按二维码下载:'长按二维码下载',
}